<template>
    <div class="lang arabic">
        <div class="info">
            <h3 class="bullet01">المركز الدولي للرعاية الصحية</h3>
            <p class="depth">
                يقدم المركز الدولي للرعاية الصحية في المركز الطبي التابع لجامعة إيهوا النسائية خدمات الرعاية الصحية الشاملة للمرضى من مختلف أنحاء العالم في بيئة ملائمة. تعد العلاقات طويلة الأجل التي أقمناها مع وكالات حكومية أجنبية مثل القوات المسلحة الأمريكية في كوريا شركة خدمات الأمن الطبي والسفر الرائدة في العالم، والهيئة الصحية الدولية في أبو ظبي ، فضلا عن المؤسسات الطبية من جميع أنحاء العالم هي من بين أصولنا القيمة التي تساعدنا في خدمة مرضانا الدوليين المتنوعين على نحو أفضل. حيث نقدم رعاية الطوارئ، ورعاية الإسعاف، والعيادات الخارجية، وبرامج علاج المرضى الداخليين وتعزيز الصحة ، ونكرس أنفسنا للصحة والابتكار الذي قد يوفر في نهاية المطاف أفضل رعاية لمرضانا وأسرهم في جميع أنحاء العالم.
            </p>
        </div>
        <div class="info">
            <h3 class="bullet01">خدمات الاستقبال والتنظيم</h3>
            <p class="depth">
                ويقدم المركز الطبي لجامعة إيهوا النسائية الرعاية للمرضى الدوليين من أكثر من 60 دولة. حيث لدينا فريق من المتخصصين والمنسقين الطبيين ذوي التعليم والخبرة العالية فهم يتحدثون الإنجليزية ، والصينية ، والروسية والعربية ويوفرون برامج خاصة ثقافية تشمل الخدمة المنزلية ، بالإضافة إلى جناح الشخصيات المهمة للنزلاء الخاصين لتوفير تجربة المرضى الأكثر راحة.
            </p>
        </div>
        <div class="info">
            <h3 class="bullet01">الخدمات المتكاملة</h3>
            <p class="depth">
                نفهم أن الوقت بصفة خاصة يعتبر أمر جوهري بالنسبة للمرضى الدوليين.ا ولهذا السبب، نقدم خدمة شاملة وملائمة للمرضى تتضمن خدمات الاستشارة والفحص في نفس اليوم كما نقدم أيضاً خدمات المنسق لتقديم مساعدة للمرضى الدوليين في جميع خطوات العملية بدءا من التسجيل وحجز الإقامة إلى الخروج من المطار وحتى خدمات النقل من المطار
            </p>
        </div>
        <div class="info">
            <h3 class="bullet01">ساعات العمل (المركز الدولي للرعاية الصحية)</h3>
            <div class="info information-call__box">
                <div class="information-call__img"><img alt="" src="/resource/icon/phon.png">
                    <h4 class="pc-none">طول أيام الأسبوع : 9:00 صباحاً حتى الساعة 5:00 مساءً</h4>
                </div>

                <div class="information-call__text">
                    <h4 class="mo-none">طول أيام الأسبوع : 9:00 صباحاً حتى الساعة 5:00 مساءً</h4>

                    <p>
                        السبت: مغلق <br>
                        أيام الأحد والاجازات الرسمية: يرجى زيارة مركز الطوارئ في الطابق الأول.
                    </p>
                </div>
            </div>
        </div>
        <div class="info">
            <h3 class="bullet01">ساعات العمل (المركز الدولي للرعاية الصحية)</h3>
            <h4 class="bullet02">يقع المركز الدولي للرعاية الصحية في الطابق الأول</h4>
            <div class="layout mt20">
                <div class="layout__inner">
                    <div class="layout__info">
                        <div class="layout__store">
                            <h4 class="layout__store-tit">1F</h4>
                            <ul class="layout__store-list">
                                <!--v-if--><!--v-if--><!--v-if--><!--v-if--><!--v-if--><!--v-if--><!--v-if--><!--v-if--><!--v-if--><!--v-if--><!--v-if-->
                                <li class="layout__store-item active">
                                    <button type="button">الأشعة</button>
                                </li><!--v-if--><!--v-if-->
                                
                            </ul>
                        </div>
                        <div class="layout__map">
                            <!-- <h3 class="tit"><span class="num">{{current.floor}}</span><span class="circle"></span></h3> -->
                            <div class="pin active" style="bottom: 27%;right:calc(9.7% - 26px)"><img
                                    src="/resource/icon/pin.svg" alt="이미지" class="active"></div><img
                                src="/displayFile.do?name=20241128.1527.25.184.jpg" alt="">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {

    }
</script>